function SvgInsurance({ color = "#6F867A", width = 20, height = 20, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.0625 15.625V15.0472C4.0625 14.83 3.97969 14.6209 3.83094 14.4628C3.51594 14.1278 2.94781 13.5237 2.56906 13.1212C2.32406 12.8606 2.1875 12.5163 2.1875 12.1584C2.1875 10.9972 2.1875 8.30687 2.1875 6.87437C2.1875 6.35687 2.60688 5.9375 3.12438 5.9375H3.12562C3.37406 5.9375 3.6125 6.03625 3.78812 6.21188C3.96375 6.3875 4.0625 6.62594 4.0625 6.87437C4.0625 7.58406 4.0625 8.4375 4.0625 8.4375"
        stroke={color || color}
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9375 15.625V15.0472C15.9375 14.83 16.0203 14.6209 16.1691 14.4628C16.4841 14.1278 17.0522 13.5237 17.4309 13.1212C17.6759 12.8606 17.8125 12.5163 17.8125 12.1584C17.8125 10.9972 17.8125 8.30687 17.8125 6.87437C17.8125 6.35687 17.3931 5.9375 16.8756 5.9375H16.8744C16.6259 5.9375 16.3875 6.03625 16.2119 6.21188C16.0362 6.3875 15.9375 6.62594 15.9375 6.87437C15.9375 7.58406 15.9375 8.4375 15.9375 8.4375"
        stroke={color || color}
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.0625 17.6184V16.0769C9.0625 15.9572 9.015 15.8422 8.93 15.7575C8.84531 15.6725 8.73031 15.625 8.61063 15.625C7.6075 15.625 5.205 15.625 4.20188 15.625C4.08219 15.625 3.96719 15.6725 3.8825 15.7575C3.7975 15.8422 3.75 15.9572 3.75 16.0769C3.75 16.665 3.75 17.6184 3.75 17.6184"
        stroke={color || color}
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9375 17.6184V16.0769C10.9375 15.9572 10.985 15.8422 11.07 15.7575C11.1547 15.6725 11.2697 15.625 11.3894 15.625C12.3925 15.625 14.795 15.625 15.7981 15.625C15.9178 15.625 16.0328 15.6725 16.1175 15.7575C16.2025 15.8422 16.25 15.9572 16.25 16.0769C16.25 16.665 16.25 17.6184 16.25 17.6184"
        stroke={color || color}
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75125 15.6257V13.9098C8.75125 13.1476 8.43875 12.4188 7.88656 11.8932C7.17188 11.2129 6.17531 10.2644 5.54594 9.66507C5.21281 9.34819 4.68813 9.35475 4.36312 9.67975L4.3625 9.68038C4.025 10.0179 4.025 10.5654 4.3625 10.9029C4.95875 11.4994 5.77719 12.3176 5.77719 12.3176"
        stroke={color || color}
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 15.6257V13.9098C11.25 13.1476 11.5625 12.4188 12.1147 11.8932C12.8294 11.2129 13.8259 10.2644 14.4553 9.66507C14.7884 9.34819 15.3131 9.35475 15.6381 9.67975L15.6387 9.68038C15.9762 10.0179 15.9762 10.5654 15.6387 10.9029C15.0425 11.4994 14.2241 12.3176 14.2241 12.3176"
        stroke={color || color}
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 3.4375C12.5 2.91969 12.0803 2.5 11.5625 2.5C10.6691 2.5 9.33094 2.5 8.4375 2.5C7.91969 2.5 7.5 2.91969 7.5 3.4375C7.5 4.06875 7.5 4.915 7.5 5.64094C7.5 6.56375 8.04125 7.40063 8.88281 7.77875C9.46062 8.03875 10 8.28125 10 8.28125C10 8.28125 10.5394 8.03875 11.1172 7.77875C11.9588 7.40063 12.5 6.56375 12.5 5.64094V3.4375Z"
        stroke={color || color}
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.98438 5.23437L9.76562 5.85937L11.0156 4.76562"
        stroke={color || color}
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgInsurance;
